
import {
  computed, defineComponent, reactive, ref, onMounted, watch,
} from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import ServicoIbsCbs from '@/servicos/Cadastros/Tributacoes/ServicoIbsCbs';
import { IClassificacaoIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/IbsCbs/IClassificacaoIbsCbs';

export default defineComponent({
  name: 'SelecionarClassificacaoIbs',
  props: {
    classificacaoSelecionada: {
      type: Object as () => IClassificacaoIbsCbs | null,
    },
    cstSelecionado: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: 'Selecione a Classificação',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classCss: {
      type: String,
      default: '',
    },
  },
  emits: ['update:classificacaoSelecionada', 'change'],
  setup(props, { emit }) {
    const refSelecionarClassificacao = ref<HTMLElement | null>(null);

    let debounce = 0;
    const servicoIbsCbs = ServicoIbsCbs;
    let todasAsClassificacoes: IClassificacaoIbsCbs[] = [];

    const state = reactive({
      listaClassificacao: [] as IOption[],
      buscandoDados: false,
      emDigitacao: false,
    });

    function pesquisarClassificacao(valorPesquisa: string) {
      state.emDigitacao = true;
      state.buscandoDados = true;
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        let listaFiltrada = todasAsClassificacoes;

        if (props.cstSelecionado) {
          listaFiltrada = listaFiltrada.filter((item) => item.codigoCstIbsCbs === props.cstSelecionado);
        }

        if (valorPesquisa) {
          listaFiltrada = listaFiltrada.filter((item) => item.codigoClassificacao.includes(valorPesquisa) || item.descricaoClassTrib.toLowerCase().includes(valorPesquisa.toLowerCase()));
        }

        state.listaClassificacao = listaFiltrada.map((item) => ({
          value: item.codigo,
          label: `${item.codigoClassificacao} - ${item.descricaoClassTrib}`,
        }));

        state.buscandoDados = false;
      }, 300);
    }

    onMounted(async () => {
      state.buscandoDados = true;
      todasAsClassificacoes = await servicoIbsCbs.obterIClassificacaoIbsCbs();
      state.buscandoDados = false;
      pesquisarClassificacao('');
    });

    watch(() => props.cstSelecionado, () => {
      pesquisarClassificacao('');
      // Limpar seleção ao mudar o CST pai
      emit('update:classificacaoSelecionada', null);
    });

    const computedCodigoSelecionado = computed({
      get: () => props.classificacaoSelecionada?.codigo || undefined,
      set: (val: number | undefined) => {
        const classificacao = todasAsClassificacoes.find((c) => c.codigo === val);
        emit('update:classificacaoSelecionada', classificacao);
      },
    });

    function change() {
      emit('change', props.classificacaoSelecionada);
    }

    function focus() {
      if (refSelecionarClassificacao.value) {
        refSelecionarClassificacao.value.focus();
      }
    }

    return {
      props,
      state,
      refSelecionarClassificacao,
      pesquisarClassificacao,
      computedCodigoSelecionado,
      change,
      focus,
    };
  },
});
